// extracted by mini-css-extract-plugin
export var calendarView = "_lr-0";